import gsap, { Power3, Linear, Power0 } from 'gsap';

const reverseAnimation = (index: number) => {
  const tl = gsap.timeline();
  switch (index) {
    // reverse section 1
    case 1:
      gsap.to(
        '.section-one-title',
        {
          autoAlpha: 0,
          x: -400,
          duration: .8,
          ease: 'power2.out',
        },
      )
      gsap.to(
          '.section-one-main > .section-one-link',
          {
            autoAlpha: 0,
            x: -780,
            duration: .6,
            ease: 'power2.out',
          },
        )
        gsap.to(
          '.section-one-header',
          {
            autoAlpha: 0,
            y: -980,
            duration: .8,
            ease: 'power2.out',
          },
        );
      break;

    // reverse section 2
    case 2:
      gsap.to('.section-two-slogan', {
        opacity: 0,
        duration: 0.8,
        ease: 'power4.out',
      });
      gsap.to('.section-two-swiper', {
        opacity: 0,
        y: 700,
        duration: 0.8,
        ease: 'power4.out',
      });
      break;

    // reverse section 3
    case 3:
      gsap.to('.section-three-item-1', {
        y: 700,
        opacity: 0,
      });
      gsap.to('.section-three-item-2', {
        y: -700,
        opacity: 0,
      });
      gsap.to('.section-three-item-3', {
        y: 700,
        opacity: 0,
      });
      gsap.to('.section-three-item-4', {
        y: -700,
        opacity: 0,
      });
      break;

    // reverse section 4
    case 4:
      gsap.to('#fourthPage-title', {
        opacity: 0,
        duration: 1,
        ease: 'power4.out',
        y: -100,
      });
      gsap.to('#fourthPage-container .boxContent_item', {
        opacity: 0,
        duration: .2,
        stagger:0,
        ease: 'power4.out',
        y: -500,
      });
      break;

    // reverse section 5
    case 5:
      const tl4 = gsap.timeline();
      tl4
        .to('.section-five-inner-wrapper-1 .section-five-text', {
          x: 200,
          autoAlpha: 0,
          duration: 1,
        })
        .to(
          '.section-five-inner-wrapper-2 .section-five-text',
          {
            x: 200,
            autoAlpha: 0,
            duration: 0.6,
          },
          '-=0.6'
        )
        .to(
          '.section-five-inner-wrapper-1 .section-five-link',
          {
            y: -50,
            autoAlpha: 0,
            duration: 0.6,
          },
          '-=0.4'
        )
        .to(
          '.section-five-inner-wrapper-2 .section-five-link',
          {
            x: 200,
            autoAlpha: 0,
            duration: 0.4,
          },
          '-=0.4'
        )
        .to('.section-five-title', {
          y: -300,
          autoAlpha: 0,
          duration: 0.6,
        },
        );
      break;
    default:
      break;
  }
};

const OnLeave = (origin: any, destination: any, direction: any) => {
  const tl = gsap.timeline();
  switch (destination.index) {
    // section 1
    case 0:
      tl.to(
        '.section-one-title',
        {
          autoAlpha: 1,
          x: 0,
          duration: 1.4,
          ease: 'power2.out',
        },
      )
        .to(
          '.section-one-main > .section-one-link',
          {
            autoAlpha: 1,
            x: 0,
            duration: 0.8,
            ease: 'power2.out',
          },
          '-=1.2'
        )
        .to(
          '.section-one-header',
          {
            autoAlpha: 1,
            y: 0,
            duration: 1.2,
            ease: 'power2.out',
          },
          '-=1.2'
        );
      reverseAnimation(2);
      break;

    //section 2
    case 1:
      // const tl = gsap.timeline();
      tl.to('.section-two-slogan',{
        opacity: 1,
        duration: 0.8,
        ease: 'power4.out',
        },
        
        
      );
      tl.to('.section-two-swiper',{
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
        ease: 'power4.out',
        },
        '+0.4'
      );
      reverseAnimation(1);
      reverseAnimation(3);
      break;

    // SectionExpertise (static — no entrance animation)
    case 2:
      break;

    // section 3 (Portfolio) — Three section removed from home
    case 3:
      const tl3 = gsap.timeline();
      tl3
        .fromTo(
          '#fourthPage-title',
          {
            y: -100,

            opacity: 0,
            ease: Power3.easeOut,
          },
          {
            duration: 0.8,
            y: 0,
            opacity: 1,
          },
        )
        .fromTo(
          '#fourthPage-container .boxContent_item',
          {
            y: 500,
            stagger:.2,
            opacity: 0,
            ease: Power3.easeOut,
          },
          {
            duration: 0.4,
            y: 0,
            stagger:.2,
            opacity: 1,
          },
          '-=0.3'
        );
      reverseAnimation(3);
      reverseAnimation(5);
      break;

    // section 4 (Five)
    case 4:
      const tl4 = gsap.timeline();
      tl4
        .fromTo(
          '.section-five-inner-wrapper-1 .section-five-text',
          {
            x: 200,
            autoAlpha: 0,
          },
          {
            x: 0,
            autoAlpha: 1,
            duration: 1,
          },
          0.2
        )
        .fromTo(
          '.section-five-inner-wrapper-2 .section-five-text',
          {
            x: 200,
            autoAlpha: 0,
          },
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.6,
          },
          '-=0.6'
        )
        .fromTo(
          '.section-five-inner-wrapper-1 .section-five-link',
          {
            y: -50,
            autoAlpha: 0,
          },
          {
            y: 0,
            autoAlpha: 1,
            duration: 0.6,
          },
          '-=0.4'
        )
        .fromTo(
          '.section-five-inner-wrapper-2 .section-five-link',
          {
            x: 200,
            autoAlpha: 0,
          },
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.4,
          },
          '-=0.4'
        )
        .fromTo(
          '.section-five-title',
          {
            y: -300,
            autoAlpha: 0,
          },
          { y: 0, autoAlpha: 1, duration: 0.6 },
          '-=0.2'
        );
        reverseAnimation(4);
        // reverseAnimation(5);
      break;

    default:
      break;
  }
};

export default OnLeave;
